import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'ee-loading',
  template: `
    <div class="flex flex-1 flex-col justify-center items-center">
      <div class="app-loader-wrapper">
        <div class="ee-logo">
          <div class="lds-ring">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
        @if (!hideMessage) {
          <span>{{ message }}</span>
        }
      </div>
    </div>
  `,
  styleUrls: ['./loading.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class LoadingComponent {
  @Input()
    message = 'EasyEviction.com';

  @Input() hideMessage = false;
}
